import {STORE_COMPANIES} from "../../constants/settings";

const initialState = {
    companies: [],
};

export default (state = initialState, action) => {
    switch (action.type) {

        case STORE_COMPANIES:
            return {
                ...state,
                companies: action.companies
            }

        default:
            return state
    }
}